// @flow

import type {GetCheckedTextList} from '../typedef';

export const getAllCheckedTextList: GetCheckedTextList = (data, checkedIdsList) => {
    return data.reduce((acc, treeItem) => {
        const {children, caption, id, disabled} = treeItem;

        const checkItem = checkedIdsList.includes(id) && caption && !disabled ? [caption] : [];

        if (children) {
            return acc.concat(checkItem, getAllCheckedTextList(children, checkedIdsList));
        }

        return acc.concat(checkItem);
    }, []);
};
